import React from 'react'
import PostPreview from '../../PostPreview'
import PostPreviewExpanded from '../../PostPreviewExpanded'

class PostListPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mobile: true,
    }
    this.handleResize = this.handleResize.bind(this)
  }
  componentDidMount() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize() {
    if (window.innerWidth >= 640) {
      this.setState({ mobile: false })
    } else {
      this.setState({ mobile: true })
    }
  }

  getPostList() {
    const postList = []
    this.props.postEdges.forEach(postEdge => {
      postList.push({
        path: postEdge.node.fields.slug,
        tags: postEdge.node.frontmatter.tags,
        cover: postEdge.node.frontmatter.assets
          ? postEdge.node.frontmatter.assets.hero
          : '',
        title: postEdge.node.frontmatter.title,
        author: postEdge.node.frontmatter.author
          ? postEdge.node.frontmatter.author.full_name
          : '',
        date: postEdge.node.fields.date,
        excerpt:
          postEdge.node.excerpt ||
          postEdge.node.frontmatter.nutgraf ||
          postEdge.node.frontmatter.description,
        timeToRead: postEdge.node.timeToRead,
        layout: postEdge.node.frontmatter.layout,
        length: postEdge.node.frontmatter.length,
        category: postEdge.node.frontmatter.category,
        html: postEdge.node.html,
      })
    })
    return postList
  }

  render() {
    const postList = this.getPostList()
    let firstPost = false
    if (this.props.currentPage == 1) {
      firstPost = postList.shift()
    }
    const { mobile } = this.state
    const cardClass = this.props.cardClass
    const posts = postList.map(function(post, index, arrayobj) {
      return (
        <PostPreview
          key={index}
          postInfo={post}
          cardClasses={'width-4/12 post-preview ' + cardClass || ''}
        />
      )
    })

    return (
      <div className="grid grid-columns post-listing">
        {firstPost && <PostPreviewExpanded postInfo={firstPost} />}
        {posts}
      </div>
    )
  }
}

export default PostListPage
